import { render, staticRenderFns } from "./WfDevDefectModal.vue?vue&type=template&id=5593dc3a&scoped=true&"
import script from "./WfDevDefectModal.vue?vue&type=script&lang=js&"
export * from "./WfDevDefectModal.vue?vue&type=script&lang=js&"
import style0 from "./WfDevDefectModal.vue?vue&type=style&index=0&id=5593dc3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5593dc3a",
  null
  
)

export default component.exports